module.exports = __webpack_public_path__ + "static/media/learnableIntroVid.2901cd10.png";